<header [ngClass]="{'device-detail-header': disableHeader}">
  <nav class="navbar navbar-expand-lg fixed-top">
    <div class="container-fluid d-flex justify-content-between align-items-center">

      <div class="company-logo">
        @if (tenantLogoUrl) {
          <img [src]="tenantLogoUrl" (click)="routeToLandingPage()" alt="Company Logo" height="35" class="tenant-logo">
        }
      </div>

      <div class="d-flex justify-content-center align-items-center flex-grow-1 filter-group">
        <ul class="navbar-nav d-flex flex-row filter-options">

          @if (!isDateParameterhidden) {
            <li class="nav-item dropdown live-option">
              <a class="nav-link btn sort-icon" role="button" [matMenuTriggerFor]="liveMenu">
                @if (liveOption.enabled) {
                  <img src="assets/images/live.svg" class="breathing-icon filter-live-dot" alt="" />
                  <span class="live-selected">{{ 'LIVE' | translate }}</span>
                } @else {
                  <mat-icon class="filter-icon">schedule</mat-icon>
                  <span [innerHTML]="(selectedRange?.value || 'Select Range') | translate"></span>
                }
                <i class="material-icons filter-chevron">expand_more</i>
              </a>
              <mat-menu #liveMenu="matMenu" xPosition="before" yPosition="below">
                <button mat-menu-item class="dropdown-item" (click)="toggleLive()">
                  <img src="assets/images/live.svg" class="breathing-icon" /> {{'LIVE' | translate}}
                </button>
                @for (range of customDateRanges; track trackByEnumValue($index, range)) {
                  <button mat-menu-item class="dropdown-item" (click)="setDateRange(range, true, true)">
                    {{ range.value | translate }}
                  </button>
                }
              </mat-menu>
            </li>
          }

          <li class="nav-item dropdown org-option" [class.org-overridden]="isOrgOverridden">
            <a class="nav-link btn sort-icon" role="button" [matMenuTriggerFor]="orgMenu"
              [matTooltip]="isOrgOverridden ? ('Org filter overridden by widgets' | translate) : ''"
              matTooltipPosition="below">
              <mat-icon class="filter-icon">account_tree</mat-icon>
              <span [class.overridden-text]="isOrgOverridden">{{selectedOrg?.name}}</span>
              @if (isOrgOverridden) {
                <span class="badge-overridden">{{ 'OVERRIDDEN' | translate }}</span>
              }
              <i class="material-icons filter-chevron">expand_more</i>
            </a>
            <mat-menu #orgMenu="matMenu" class="organizations-dropdown" xPosition="before" yPosition="below">
              @if (organizations) {
                @if (organizationsList?.length > 15) {
                  <input type="search" class="form-control border-0 shadow mt-n2" [placeholder]="'Search Organization' | translate"
                    [(ngModel)]="orgSearchText"
                    (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
                }
                <ng-container *ngTemplateOutlet="nodeTree;
                              context: {list: organizations | filter: orgSearchText , level: 0}"></ng-container>
                <ng-template #nodeTree let-list="list" let-level="level">
                  @for (org of list; track trackByOrgLevelId($index, org)) {
                    <button mat-menu-item class="dropdown-item link-cursor sort-icon" [ngClass]="'child-level-'+level" (click)="setOrg(org)">
                      {{org.name}}
                    </button>
                    @if (org.children?.length > 0) {
                      <ng-container *ngTemplateOutlet="nodeTree; context: {list: org.children, level: level+1}"></ng-container>
                    }
                  }
                </ng-template>
              }
            </mat-menu>
          </li>

          @if (!isDateParameterhidden) {
            <li class="nav-item dropdown param-option">
              <a class="nav-link btn sort-icon" role="button" [matMenuTriggerFor]="paramMenu">
                <mat-icon class="filter-icon">bubble_chart</mat-icon>
                <span>{{selectedParameter?.name}}</span>
                <i class="material-icons filter-chevron">expand_more</i>
              </a>
              <mat-menu #paramMenu="matMenu" xPosition="before" yPosition="below">
                @for (risk of parameters; track trackByLookupId($index, risk)) {
                  <button mat-menu-item class="dropdown-item" (click)="setAnalyte(risk)">
                    {{risk.name}}
                  </button>
                }
              </mat-menu>
            </li>
          }
        </ul>
      </div>

      <div class="header-actions">
        @if (isAiAnalystButtonVisible) {
          <a class="ask-ai-btn" [routerLink]="aiAnalystRoute" routerLinkActive="is-active"
            [matTooltip]="'AI Data Analyst' | translate" [attr.aria-label]="'AI Data Analyst' | translate">
            <mat-icon>auto_awesome</mat-icon>
            <span class="ask-ai-label">{{ 'Ask AI' | translate }}</span>
          </a>
        }
        <app-notification-center class="header-bell"></app-notification-center>
        <a class="header-icon-btn" href="https://support.appliedparticle.io/" target="_blank" rel="noopener noreferrer"
          [matTooltip]="'Help Center' | translate" [attr.aria-label]="'Help Center' | translate">
          <mat-icon>help_outline</mat-icon>
        </a>
        <span class="header-divider"></span>
      </div>

      <div class="d-flex align-items-center user-profile dropdown">
        <a class="btn d-flex align-items-center" (click)="showUserPopupFn()">
          <div class="user-info">
            <strong class="user-name">{{userData?.fullName}}</strong>
            <div class="user-job">{{userData?.jobTitle}}</div>
          </div>
          @if (userInitials) {
            <span class="user-avatar">{{ userInitials }}</span>
          } @else {
            <i class="material-icons user-icon">account_circle</i>
          }
        </a>
      </div>
    </div>
  </nav>
</header>

<div class="time_range" [ngClass]="{'time_range_active': isDateFilter}">
  <ul class="dropdown-content calander-menu-div new-data-range-calander" id="dropdown3" tabindex="0">
    <a class="menu-close p-0" (click)="isDateFilter = false;"><i class="material-icons dp48">close</i></a>
    <li tabindex="0">
      <div class="calander-border-div from-calander">
        <h4 class="light-grey-text">{{ 'Select' | translate }}</h4>
        <h3 class="big-ttl">{{ 'Current Range' | translate }}</h3>
        <div class="all-input-div">
          <div class="d-flex justify-content-center align-items-center">
            <div>
              <input [owlDateTimeTrigger]="dtStart" [owlDateTime]="dtStart" selectMode="rangeFrom"
                [(ngModel)]="startDateInput" (ngModelChange)="inputDateChanged('from')" [max]="endDate" readonly
                [placeholder]="'From' | translate">
                <owl-date-time panelClass="header-owl-date-picker" [hour12Timer]="is12HourFormat" #dtStart></owl-date-time>
              </div>
              <i class="fa fa-arrow-right px-1" aria-hidden="true"></i>
              <div>
                <input [owlDateTimeTrigger]="dtEnd" [owlDateTime]="dtEnd" selectMode="rangeTo"
                  [(ngModel)]="endDateInput" (ngModelChange)="inputDateChanged('to')" [min]="startDate"
                  readonly [placeholder]="'To' | translate">
                  <owl-date-time panelClass="header-owl-date-picker" [hour12Timer]="is12HourFormat" #dtEnd></owl-date-time>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <a class="end-now-link" (click)="setEndDateToNow()">{{ 'Now' | translate }}</a>
            </div>
            @if (showPreviuosDateRange) {
              <h3 class="big-ttl mt-4 sort-icon">{{ 'Comparison Range' | translate }}</h3>
              <div class="all-input-div sort-icon">
                <div class="d-flex justify-content-center align-items-center">
                  <div>
                    <input [owlDateTimeTrigger]="dtPrevStart" [owlDateTime]="dtPrevStart" selectMode="rangeFrom"
                      [(ngModel)]="prevStartDateInput" (ngModelChange)="inputDateChanged('prevFrom')"
                      [max]="prevEndDate" readonly [placeholder]="'From' | translate">
                      <owl-date-time panelClass="header-owl-date-picker" [hour12Timer]="is12HourFormat" #dtPrevStart></owl-date-time>
                    </div>
                    <i class="fa fa-arrow-right px-1" aria-hidden="true"></i>
                    <div>
                      <input [owlDateTimeTrigger]="dtPrevEnd" [owlDateTime]="dtPrevEnd" selectMode="rangeTo"
                        [(ngModel)]="prevEndDateInput" (ngModelChange)="inputDateChanged('prevTo')" [min]="prevStartDate"
                        [max]="today" readonly [placeholder]="'To' | translate">
                        <owl-date-time panelClass="header-owl-date-picker" [hour12Timer]="is12HourFormat" #dtPrevEnd></owl-date-time>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </li>
            <li tabindex="0" class="sort-icon">
              <a class="main-btn apply-btn sort-icon" (click)="applyFilter(true)">{{ 'Apply' | translate }}</a>
            </li>
          </ul>
        </div>

        @if (showUserPopup) {
          <div class="custom-popup user-setting-popup modal left">
            <div class="modal-dialog" (clickOutside)="closeUserPopup();" [exclude]="'.user-profile,.user-icon,.user-name,.user-job'">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="mb-2">
                    <div class="inner-content">
                      <div class="inner-paragraph">
                        <span class="ttl">{{ 'EMAIL' | translate }}</span>
                        <span class="content">{{userData?.userName}}</span>
                      </div>
                      <hr>
                        <div class="inner-paragraph">
                          <div class="d-flex justify-content-between settings-modal" (click)="openUserPreferencesDialog()">
                            <img src="assets/images/Settings.svg" class="settings-icon">
                            <span class="settings-content">{{ 'User Account Settings' | translate }}</span>
                            <i class="fa fa-chevron-right"></i>
                          </div>
                        </div>
                        <hr>
                          <div class="buttons-container">
                            <button (click)="logout();">{{ 'Log Out' | translate }}
                              <i class="fas fa-sign-out-alt"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- header filter popup -->
                    @if (showHeaderFilterPopup) {
                      <div class="custom-popup header-filters-model left desktop-none" (clickOutside)="showHeaderFilterFn()" [exclude]="'.filter-icon'">
                        <div class="px-2 d-flex align-items-center">
                          <i class="fa fas fa-arrow-left p-2" (click)="showHeaderFilterFn()"></i>
                          <span class="pl-3">{{ 'Select Filters' | translate }}</span>
                        </div>
                        <hr>
                          <nav class="navbar w-100 sm-header-filters">
                            <div class="nav-item mb-2 dropdown sort-icon">
                              <a class="nav-link btn py-2 sort-icon {{disableMenu ? 'disabled' : ''}}" id="dropdown1-mobile" role="button" [matMenuTriggerFor]="mobileOrgMenu">
                                {{selectedOrg?.name}}<i class="material-icons right sort-icon">expand_more</i>
                              </a>
                              <mat-menu #mobileOrgMenu="matMenu" class="organizations-dropdown" xPosition="before" yPosition="below">
                                @if (organizations) {
                                  <ng-container *ngTemplateOutlet="mobileNodeTree; context: {list: organizations, level: 0}"></ng-container>
                                  <ng-template #mobileNodeTree let-list="list" let-level="level">
                                    @for (org of list; track trackByOrgLevelId($index, org)) {
                                      <button mat-menu-item class="dropdown-item link-cursor sort-icon" [ngClass]="'child-level-'+level" (click)="setOrg(org)">{{org.name}}</button>
                                      @if (org.children?.length > 0) {
                                        <ng-container *ngTemplateOutlet="mobileNodeTree; context: {list: org.children, level: level+1}"></ng-container>
                                      }
                                    }
                                  </ng-template>
                                }
                              </mat-menu>
                            </div>
                            @if (!isDateParameterhidden) {
                              <div class="nav-item mb-2 dropdown sort-icon">
                                <a class="nav-link btn py-2 disable-on-device-detail sort-icon" id="dropdown2-mobile" role="button" [matMenuTriggerFor]="mobileParamMenu">
                                  {{selectedParameter?.name}}<i class="material-icons right sort-icon">expand_more</i>
                                </a>
                                <mat-menu #mobileParamMenu="matMenu" xPosition="before" yPosition="below">
                                  @for (risk of parameters; track trackByLookupId($index, risk)) {
                                    <button mat-menu-item class="dropdown-item link-cursor sort-icon" (click)="setAnalyte(risk)">
                                      {{risk.name}}
                                    </button>
                                  }
                                </mat-menu>
                              </div>
                              <div class="nav-item d-flex">
                                @if (liveOption.show) {
                                  <div class="live-option p-2" [class.disabled]="!liveOption.enabled" (click)="toggleLive()">
                                    @if (liveOption.enabled) {
                                      <div class="live-text spinner-grow live-spinner" role="status">
                                        <span class="sr-only">{{ 'Loading' | translate }}...</span>
                                      </div>
                                    }
                                    <span class="live-text ml-1">{{ 'LIVE' | translate }}</span>
                                  </div>
                                }
                                <div class="nav-item dropdown disabled sort-icon">
                                  <a class="nav-link btn py-2 disable-on-device-detail {{disableMenu ? 'disabled' : ''}}" id="dropdown3-mobile" role="button" [matMenuTriggerFor]="mobileLiveMenu">
                                    <span class="sort-icon" [innerHTML]="(selectedRange?.value || 'Select Range') | translate" [class.text-decoration-line-through]="liveOption.enabled"></span><i class="material-icons right sort-icon">expand_more</i>
                                  </a>
                                  <mat-menu #mobileLiveMenu="matMenu" xPosition="before" yPosition="below">
                                    @for (range of customDateRanges; track trackByEnumValue($index, range)) {
                                      <button mat-menu-item class="dropdown-item link-cursor sort-icon" (click)="setDateRange(range, true, true)">
                                        {{ range.value | translate}}
                                      </button>
                                    }
                                  </mat-menu>
                                </div>
                              </div>
                            }
                          </nav>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
